
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/capcompetence",
      function () {
        return require("private-next-pages/capcompetence.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/capcompetence"])
      });
    }
  